/**
 * Khối compute: hồ sơ giá/khối lượng (Market Profile, Volume Profile, Footprint,
 * Delta Profile).
 *
 * Một nhóm trong `computeIndicatorComputationResult`, tách riêng (split 2026-09-30).
 * Đây là nhóm đắt nhất (synthesizeTicksFromBar + computeFootprintBars trên cả lịch
 * sử) và là nhóm duy nhất ngoài dòng tiền cần `options` — `asyncVolumeProfiles` cho
 * phép dùng kết quả đã tính sẵn, `mtfBars` cho phép backfill từ khung nhỏ hơn.
 */
import { computeDeltaProfile, computeFootprintBars, computeMarketProfile, computeVolumeProfile, synthesizeTicksFromBar, } from "../../indicators/utils";
export function computeProfileBlocks(raw, plan, options) {
    const marketProfileByKey = new Map();
    for (const [key, config] of plan.marketProfileConfigs) {
        const start = config.sessionStart ?? (raw[0]?.date ? new Date(raw[0].date).getTime() : Date.now());
        const end = config.sessionEnd ?? (raw[raw.length - 1]?.date ? new Date(raw[raw.length - 1].date).getTime() : Date.now());
        const ticks = raw.flatMap(bar => synthesizeTicksFromBar(bar, config.tickSize));
        const data = computeMarketProfile(ticks, start, end, config.tickSize, config.tpoPeriodMinutes);
        marketProfileByKey.set(key, data);
    }
    const volumeProfileByKey = new Map();
    for (const [key, config] of plan.volumeProfileConfigs) {
        const cachedProfile = options?.asyncVolumeProfiles?.[key];
        if (cachedProfile) {
            volumeProfileByKey.set(key, cachedProfile);
        }
        else {
            let targetData = raw;
            if (options?.mtfBars) {
                const backfillTf = options.mtfBars["1m"] ? "1m" : (options.mtfBars["5m"] ? "5m" : undefined);
                if (backfillTf && options.mtfBars[backfillTf]?.length > 0) {
                    targetData = options.mtfBars[backfillTf];
                }
            }
            const data = computeVolumeProfile(targetData, config.priceTickSize);
            volumeProfileByKey.set(key, data);
        }
    }
    const footprintByKey = new Map();
    for (const [key, config] of plan.footprintConfigs) {
        const data = computeFootprintBars(raw, config.barIntervalMs, config.priceTickSize);
        footprintByKey.set(key, data);
    }
    const deltaProfileByKey = new Map();
    for (const [key, config] of plan.deltaProfileConfigs) {
        const footprintBars = computeFootprintBars(raw, config.barIntervalMs, config.priceTickSize);
        const data = computeDeltaProfile(footprintBars, config.smaPeriod);
        deltaProfileByKey.set(key, data);
    }
    return {
        marketProfileByKey,
        volumeProfileByKey,
        footprintByKey,
        deltaProfileByKey,
    };
}
